import { useListItemDataProvider } from "@circle-react-shared/uikit/SortableList";
import classnames from "classnames";

export const ThumbnailImagePlaceholder = ({ isOverlay = false }: any) => {
  const { item }: any = useListItemDataProvider();
  return (
    <div
      className={classnames(
        "rounded-md border-2 border-transparent p-0.5 opacity-50",
        {
          "!opacity-100": isOverlay,
        },
      )}
    >
      <img
        loading="eager"
        src={item.preview}
        className="size-12 rounded-md object-cover"
        alt={item.file.name}
      />
    </div>
  );
};
